import React, { useContext, useCallback } from 'react';
import { bool, func, string } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import * as analytics from '../../analytics';
import { ProductDetailsContext } from '../ProductDetailsContext';
import ProductDetailsBadge from './ProductDetailsBadge.component';

const ProductDetailsTitle = (props) => {

  const { product, itemId } = useContext(ProductDetailsContext);

  const publish = useCallback((event, pageType) => {
    analytics.track('click', {
      element: 'product name',
    });
  }, []);
  const handleClick = useCallback((event) => {
    const { pageType, onClick } = props;
    publish(event, pageType);
    if (onClick) {
      onClick(event, { product });
    }
  }, [product]);

  const labelHtml = useCallback(({ product: localProduct }) => {
    const { channel } = useContext(ExperienceContext);
    const { link, pageType, badge } = props;
    const isMobile = channel === 'mobile';
    const titleClassName = isMobile && pageType === 'PEP'
      ? 'product-details__title--mobile'
      : 'product-details__title';
    const { identifiers } = localProduct;
    const ProductTitle = () => (
      <h1 className={titleClassName}>
        {badge && <ProductDetailsBadge itemId={itemId} />}
        {identifiers.productLabel}
      </h1>
    );

    if (link) {
      return (
        <a href={identifiers.canonicalUrl} onClick={handleClick} className="product-details__click-title">
          <ProductTitle />
        </a>
      );
    }
    return <ProductTitle />;
  }, [product]);

  if (!product) return null;
  return (
    <span className="product-title">
      {labelHtml({ ...props, product })}
    </span>
  );
};

ProductDetailsTitle.propTypes = {
  badge: bool,
  link: bool,
  onClick: func,
  pageType: string,
};

ProductDetailsTitle.defaultProps = {
  badge: false,
  link: false,
  onClick: null,
  pageType: 'PEP',
};

export default ProductDetailsTitle;
